// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"articles_wrapper__dhWCj"};